    import fileModel from '@/shared/file/file-model';

export default {
  default() {
    return {
      id: null,
      dorsal: "-",
      picture: {
        name:"",
        size:0,
        url:""
      }
    }
  },

  forSimple(data){
    return  {
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : ''
    }
  },

  forCreate(data) {
    return {
      ...data,
      picture: fileModel.toDatabaseFile(data.picture)
    };
  },

  forTeam(data) {
    return  { 
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : '',
      picture: data.picture ? fileModel.toDatabaseFile(data.picture) : {
          name:"",
          size:0,
          url:""
        },
      birthdate: data.birthdate ? data.birthdate: '',
      dorsal: data.dorsal ? data.dorsal: '',
      phone: data.phone ? data.phone: '',
      namePublic: data.namePublic ? data.namePublic : '',
      email: data.email ? data.email : '',
      dni: data.dni ? data.dni : '',
      position: data.position ? data.position : ''
    }
  },
  
  forUpdate(data) {
    return {
      ...data,
      picture: fileModel.toDatabaseFile(data.picture)
    };
  }
};



// WEBPACK FOOTER //
// ./src/entities/player/player-model.js